export const CP_PATH = '/cp';
export const BASE_PATH = '';
export const LOGIN_PATH = `${CP_PATH}/login`;
export const DASHBOARD_PATH = `${CP_PATH}/dashboard`;
export const UNMAPPED_PRODUCTS_PATH = `${CP_PATH}/unmapped-products`;
export const ORDERS_PATH = `${CP_PATH}/orders`;
export const ORDER_DETAIL_PATH = `${ORDERS_PATH}/:id`;
export const REPORTS_PATH = `${CP_PATH}/reports`;
export const ORDERS_LISTING_PATH = `${ORDERS_PATH}/orders-listing`;
export const ADVANCE_PAYMENT_PATH = `${ORDERS_PATH}/advance-payment`;
export const RETURN_ORDERS_PATH = `${ORDERS_PATH}/return-orders`;
export const ROOT_PRODUCTS_PATH = `${CP_PATH}/products`;
export const SELLERS_PATH = `${CP_PATH}/sellers`;
export const SELLERS_LISTING_PATH = `${SELLERS_PATH}/all-sellers`;
export const CATEGORIES_MODERATION_PATH = `${CP_PATH}/moderation/categories-moderation`;
export const UPLOADS_MODERATION_PATH = `${CP_PATH}/moderation/uploads-moderation`;
export const TYPE_MODERATION_PATH = `${CP_PATH}/moderation/type-moderation`;
export const TYPE_MODERATION_DETAIL = `${CP_PATH}/moderation/type-moderation/:id/:slug`;
export const CATEGORY_MODERATION_DETAIL = `${CP_PATH}/moderation/category-moderation/:id/:slug`;
export const WEIGHT_MODERATION_PATH = `${CP_PATH}/moderation/weight-moderation`;
export const WEIGHT_MODERATION_DETAIL = `${CP_PATH}/moderation/weight-moderation/:id`;
export const ADD_SELLER_PATH = `${SELLERS_PATH}/add-seller`;
export const EDIT_SELLER_PATH = `${SELLERS_PATH}/edit-seller/:id`;
export const PRODUCTS_PATH = `${ROOT_PRODUCTS_PATH}/listing`;
export const EDIT_PRODUCT_CP = `${ROOT_PRODUCTS_PATH}/edit-product/:id`;
export const PRODUCT_IMAGES = `${ROOT_PRODUCTS_PATH}/:id/images`;
export const REVIEWS = `${CP_PATH}/products/reviews`;
export const EDIT_REVIEW = `${REVIEWS}/edit-review/:id`;
export const EDIT_SELLER_COMMENT = `${REVIEWS}/edit-seller-comment/:id`;
export const FINANCE_PATH = `${CP_PATH}/finance`;
export const ORDER_OVERVIEW_FINANCE = `${FINANCE_PATH}/transaction-history`;
export const ACCOUNT_STATEMENT_FINANCE = `${FINANCE_PATH}/account-statement`;
export const ACCOUNT_STATEMENT_DETAIL = `${ACCOUNT_STATEMENT_FINANCE}/detail/:id`;
export const NOT_FOUND = `${CP_PATH}/page-not-found`;
export const SERVER_ERROR = `${CP_PATH}/unexpected-error`;
export const ACCESS_DENIED = `${CP_PATH}/access-denied`;
export const ROLES_PATH = `${CP_PATH}/settings/roles`;
export const MANAGE_ROLES = `${CP_PATH}/roles/:id/edit`;
export const ADD_ROLES = `${CP_PATH}/roles/add`;
export const USERS_PATH = `${CP_PATH}/settings/users`;
export const LOCATIONS_PATH = `${CP_PATH}/settings/locations`;
export const PUBLISH_PRODUCT = `${CP_PATH}/unmapped-products/publish-product/:id`;
export const ALL_IMAGES_PATH = `${CP_PATH}/moderation/attachments`;
export const REAL_TIME_STATS_PATH = `${CP_PATH}/real-time-statistics`;
export const CARTS = `${CP_PATH}/orders/carts`;
export const CALLS_PATH = `${CP_PATH}/orders/calls`;
export const SALES_REPORT_PATH = `${REPORTS_PATH}/sales-report`;
export const FOLLOW_UPS_PATH = `${CP_PATH}/kpis/todos`;
